import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { TableLoader } from "../../../Common/ShimmerLoader";
import * as Yup from "yup";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { GetAllTertiaryTripReport } from "../../../Apis/userCreationApi";

const EditTeritaryTripDetails = ({ showModal, setShow, selectedData, startDate, endDate,VehicleNumber, onUpdateSuccess }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setPreviewImage(null);
    setShow(false);
  };

  const initialValues = {
    netWeight: selectedData ? selectedData.netWeight : "",
    grossWeight: selectedData ? selectedData.grossWeight : "",
    mswType: selectedData ? selectedData.mswType : "",
  };

  const validationSchema = Yup.object().shape({
    netWeight: Yup.string()
      .matches(/^\d+(\.\d+)?$/, "Only numbers or decimals are allowed")
      .required("Net Weight is required"),
    grossWeight: Yup.string()
      .matches(/^\d+(\.\d+)?$/, "Only numbers or decimals are allowed")
      .required("Gross Weight is required"),
    mswType: Yup.string().required("MSW Type is required"),
  });

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      setIsLoading(true);

      // Create FormData object
      const formData = new FormData();
      formData.append("TertiaryTripTransactionId", selectedData.tertiaryTripTransactionId);
      formData.append("NetWeight", values.netWeight);
      formData.append("GrossWeight", values.grossWeight);
      formData.append("MswType", values.mswType);

      const updateDetails = await axios.put(
        `${API_BASE_URL1}MasterCreate/UpdateTeritiaryTripTransaction`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (updateDetails.status === 200) {
        toast.success(updateDetails.data);

        // Refresh report data
        const queryParams = new URLSearchParams({
          fromDate: startDate || "",
          toDate: endDate || "",
          VehicleNumber: VehicleNumber || " ",
        }).toString();

        const updatedData = await GetAllTertiaryTripReport(queryParams);
        if (updatedData && updatedData.length > 0) {
          // Pass the updated data to the parent component
          onUpdateSuccess(updatedData);
        } else {
          onUpdateSuccess([]); // Handle case where no data is returned
        }

        resetForm();
        handleClose();
      }

      setSubmitting(false);
    } catch (error) {
      if (error.response?.status === 400) {
        const validationErrors = error.response.data.errors || error.response.data;
        let errorMessages = [];

        Object.keys(validationErrors).forEach((key) => {
          const val = validationErrors[key];
          if (Array.isArray(val)) val.forEach((msg) => errorMessages.push(msg));
          else errorMessages.push(val);
        });

        errorMessages.forEach((msg) => toast.error(msg));
        return { success: false, errors: validationErrors };
      }

      console.error(error);
      toast.error(error.response?.data || "Failed to update Tertiary Trip");
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Transferstation Transaction
          </Modal.Title>
          <i className="fa-solid fa-xmark close-container" onClick={handleClose}></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnChange={true}
            validateOnBlur={true}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="Net Weight">
                      Net Weight <span className="text-danger">*</span>
                    </label>
                    <Field name="netWeight">
                      {({ field, form }) => (
                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          onInput={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            const parts = value.split(".");
                            if (parts.length > 2) {
                              value = parts[0] + "." + parts[1];
                            }
                            form.setFieldValue("netWeight", value);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage name="netWeight" component="div" style={{ color: "red" }} className="small" />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label htmlFor="Gross Weight">
                      Gross Weight <span className="text-danger">*</span>
                    </label>
                    <Field name="grossWeight">
                      {({ field, form }) => (
                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          onInput={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            const parts = value.split(".");
                            if (parts.length > 2) {
                              value = parts[0] + "." + parts[1];
                            }
                            form.setFieldValue("grossWeight", value);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage name="grossWeight" component="div" style={{ color: "red" }} className="small" />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label htmlFor="MSW Type">
                      MSW Type <span className="text-danger">*</span>
                    </label>
                    <Field name="mswType">
                      {({ field, form }) => (
                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^a-zA-Z]/g, "");
                            form.setFieldValue("mswType", e.target.value);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage name="mswType" component="div" style={{ color: "red" }} className="small" />
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <button type="submit" className="deployment-button" disabled={isSubmitting}>
                    <i className="fa-solid fa-check done-container"></i>
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditTeritaryTripDetails;